import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "display": "contents"
  },
  class: "stocklist"
};
const _hoisted_2 = {
  class: "m-t-10 table_90 p-b-20 border-r-10 text-black f-12",
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form = _resolveComponent("el-form");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_col, {
      span: 30,
      style: {
        "margin-top": "40px",
        "display": "contents",
        "margin-left": "10px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form, {
        ref: "form",
        model: _ctx.filter,
        "label-width": "130px",
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              class: "label-sku",
              label: "规格型号（SKU）"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.form_requst.sku,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form_requst.sku = $event),
                placeholder: "请输入规格型号（SKU）"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "物料名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.form_requst.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form_requst.name = $event),
                placeholder: "请输入物料名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "物料编码"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.form_requst.fnumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form_requst.fnumber = $event),
                placeholder: "请输入物料编码"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "批号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: $data.form_requst.bn,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form_requst.bn = $event),
                placeholder: "请输入批号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4,
            offset: 2,
            style: {
              "display": "flex",
              "align-items": "center"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              size: "mini",
              onClick: $options.search
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("搜索")])),
              _: 1,
              __: [4]
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              size: "mini",
              onClick: $options.reset
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("重置")])),
              _: 1,
              __: [5]
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              size: "mini",
              onClick: $options.batchExport
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("导出")])),
              _: 1,
              __: [6]
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_vxe_table, {
      border: "",
      resizable: "",
      "show-overflow": "",
      ref: "xTable",
      height: "650",
      "scroll-x": {
        enabled: false
      },
      "scroll-y": {
        enabled: false
      },
      "header-cell-style": $data.header_style,
      data: $data.tableData
    }, {
      default: _withCtx(() => [_createVNode(_component_vxe_column, {
        field: "fnumber",
        title: "物料编码",
        "header-align": "center",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        field: "sku",
        title: "规格型号（SKU）",
        "header-align": "center",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "name",
        title: "物料名称",
        "header-align": "center",
        align: "left"
      }), _createVNode(_component_vxe_column, {
        field: "bn",
        title: "批号",
        "header-align": "center",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        field: "factory_price",
        title: "出厂价（¥）",
        "header-align": "center",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        field: "FDate",
        title: "入库日期",
        "header-align": "center",
        align: "center"
      })]),
      _: 1
    }, 8, ["header-cell-style", "data"]), _createVNode(_component_el_pagination, {
      "current-page": $data.form_requst.page,
      "page-sizes": [20, 60, 100],
      "page-size": $data.form_requst.size,
      layout: "total, sizes, prev, pager, next, jumper",
      total: $data.count,
      class: "m-t-10 m-b-20 table_90",
      onSizeChange: $options.handleSizeChange,
      onCurrentChange: $options.handleCurrentChange
    }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])])]),
    _: 1
  });
}